module.exports = __webpack_public_path__ + "static/media/apartment.6224cc6b.png";